import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import './NewCircleModalCategories.scss';
import './NewCircleModalResults.scss';
import { getDepartments, CATALOG_IMAGE_FALLBACK } from '../../../../Helpers/shop_helpers';

import SmartImage from '../../../General/SmartImage';

const NewCircleModalCategories = props => {
  const { shop } = props;

  const departments = _.orderBy(getDepartments(shop), 'eliteNumPromoting', 'desc').filter(d => !d.isHidden);

  const isIndustrySelected = industry => props.selectedIndustries.some(i => i.id === industry.id);
  const isDepartmentSelected = department => props.selectedDepartments.some(d => d.id === department.id);

  const toggleIndustry = industry =>
    props.setSelectedIndustries(
      isIndustrySelected(industry) ? props.selectedIndustries.filter(i => i.id !== industry.id) : [...props.selectedIndustries, industry]
    );

  const toggleDepartment = department =>
    props.setSelectedDepartments(
      isDepartmentSelected(department) ? props.selectedDepartments.filter(d => d.id !== department.id) : [...props.selectedDepartments, department]
    );

  const numCurrentSelected = props.selectedIndustries.length + props.selectedDepartments.length;

  const results = [...departments];

  return (
    <div className='new-circle-modal-categories-container new-circle-modal-results-container'>
      <div className='new-circle-modal-body-title-container'>
        <div className='title'>What do you want help discovering?</div>
        <div className='subtitle'>
          Pick a few product categories — we'll use them to recommend curators for your circle who know those categories best.
        </div>
      </div>
      <div className='results'>
        {results.map(result => {
          const isIndustry = !result.Industry_id;

          const toggle = () => (isIndustry ? toggleIndustry(result) : toggleDepartment(result));

          const isSelected = isIndustry ? isIndustrySelected(result) : isDepartmentSelected(result);
          const isAnotherSelected = !isSelected && !!numCurrentSelected;
          const additionalClasses = { selected: isSelected, 'another-selected': isAnotherSelected };
          return (
            <div className={cn('result', additionalClasses)} key={`${result.id}-${isIndustry ? 'industry' : 'department'}`} onClick={toggle}>
              <div className={cn('image-container', additionalClasses)}>
                <SmartImage src={result.exampleProductImage || CATALOG_IMAGE_FALLBACK} alt={result.name} />
              </div>
              <div className={cn('name-container', additionalClasses)}>
                <div className='name'>{result.name}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

NewCircleModalCategories.propTypes = {
  shop: PropTypes.object.isRequired,

  selectedIndustries: PropTypes.array.isRequired,
  selectedDepartments: PropTypes.array.isRequired,
  setSelectedIndustries: PropTypes.func.isRequired,
  setSelectedDepartments: PropTypes.func.isRequired
};

export default NewCircleModalCategories;
